import { render, staticRenderFns } from "./CountryPhoneCode.vue?vue&type=template&id=36b5a87a&"
import script from "./CountryPhoneCode.vue?vue&type=script&lang=js&"
export * from "./CountryPhoneCode.vue?vue&type=script&lang=js&"
import style0 from "./CountryPhoneCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
